/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, Dispatch, SetStateAction } from 'react'

import { Button, Col, Form, Input, PageHeader, Radio, Row, Table } from 'antd'
import { MaskedInput } from 'antd-mask-input'
import ID_COMPONENTE from 'config/idComponente'
import cnpj from 'Hooks/useMask/cnpj'
import { Empresa } from 'Models/cadastros'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import { ServiceListResponse } from 'Types/ServiceResponse'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'

interface IProps {
  empresas: Empresa[]
  setEmpresas: Dispatch<SetStateAction<Empresa[]>>
}

const ModalEmpresaAssociada = ({ empresas, setEmpresas }: IProps) => {
  const [dataItens, setDataItens] = useState<
    ServiceListResponse<Empresa> | undefined
  >()
  const [formulario] = Form.useForm<IFormEmpresasFilter>()
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)
  const [chavesLinhasSelecionadas, setChavesLinhasSelecionadas] = useState<
    React.Key[]
  >([])

  const pesquisaEmpresas = async (filtros: IFormEmpresasFilter) => {
    if (filtros.cnpj) {
      filtros.cnpj = cnpj.clean(filtros.cnpj).toString()
    }

    if (filtros.ativo === undefined) {
      filtros.ativo = true
    }

    const parametros: ParamsRequest = {
      pageNumber: 1,
      pageSize: 10000,
    }

    const { data } = await WsCadastroService.empresas.getList(
      ID_COMPONENTE.DOCAS,
      filtros,
      parametros,
    )

    if (data.items) {
      const novasChaves: React.Key[] = []

      for (let i = 0; i < data.items.length; i++) {
        data.items[i].key = data.items[i].id

        if (empresas.length > 0) {
          const id = data.items[i].id

          if (empresas.find((f) => f.id === id)) {
            novasChaves.push(id)
          }
        }
      }

      if (novasChaves.length > 0) {
        setChavesLinhasSelecionadas(novasChaves)
      }
    }

    setDataItens(data)
    setCarregandoPesquisa(false)
  }

  const adicionaOuRemoveEmpresa = (
    chavesLinhasSelecionadas: React.Key[],
    linhasSelecionadas: Empresa[],
  ) => {
    setChavesLinhasSelecionadas(chavesLinhasSelecionadas)
    setEmpresas(linhasSelecionadas)
  }

  return (
    <Form onFinish={pesquisaEmpresas} layout="vertical" form={formulario}>
      <PageHeader
        ghost={false}
        title="Consultar Empresa"
        extra={[
          <Button
            key="pesquisa"
            type="primary"
            htmlType="submit"
            loading={carregandoPesquisa}
            onClick={() => setCarregandoPesquisa(true)}
          >
            Pesquisar
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={8} md={8} sm={12} xs={24}>
            <Form.Item name="nome" label="Nome:">
              <Input type="text" />
            </Form.Item>
          </Col>

          <Col span={8} md={8} sm={12} xs={24}>
            <Form.Item name="cnpj" label="CNPJ:">
              <MaskedInput mask="11.111.111/1111-11" />
            </Form.Item>
          </Col>

          <Col span={8} md={8} sm={12} xs={24}>
            <Form.Item name="ativo" label="Situação:">
              <Radio.Group defaultValue={true}>
                <Radio value={true}>Ativo</Radio>
                <Radio value={false}>Inativo</Radio>
                <Radio value={null}>Ambos</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'Nome',
                  key: 'nome',
                  dataIndex: 'nome',
                },
                {
                  title: 'CNPJ',
                  key: 'cnpj',
                  dataIndex: 'cnpj',
                },
                {
                  title: 'Situação',
                  key: 'ativo',
                  dataIndex: 'ativo',
                  render: (ativo: boolean) => (ativo ? 'ATIVO' : 'INATIVO'),
                },
              ]}
              dataSource={dataItens?.items || []}
              scroll={{ y: 415 }}
              pagination={false}
              rowSelection={{
                selectedRowKeys: chavesLinhasSelecionadas,
                onChange: adicionaOuRemoveEmpresa,
                hideSelectAll: true,
              }}
            />
          </Col>
        </Row>
      </PageHeader>
    </Form>
  )
}

export default ModalEmpresaAssociada
